import { PermissionType } from '@watershed/constants/permissions';

import useHasPermission from './useHasPermission';

export function useUserCanUpdateDatasourceTask() {
  return useHasPermission(PermissionType.ManageMeasurement);
}

export function useUserCanCreateProject() {
  return useHasPermission(PermissionType.ManageMeasurement);
}

export function useUserCanExportFacilitiesData() {
  return useHasPermission(PermissionType.ManageMeasurement);
}

export function useUserCanEditUploadTaskInstructions() {
  return useHasPermission(PermissionType.Admin);
}
